import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Announcement } from 'src/app/pages/announcement/Announcement';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  constructor(private http: HttpClient) { }

  pushFileToStorage(body) {
    const fd = new FormData();
    fd.append('file', body);
    return this.http.post(`${environment.apiUrl}/Announcement/FileUpload`,
      fd,
    );
  }
  
  public search(UserID, RoleName): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/Announcement/GetData`);
  }

  public submit(announcement): Observable<Announcement[]> {
    
    return this.http.post<Announcement[]>(`${environment.apiUrl}/Announcement/Insert`, announcement);
  }

  public update(announcement): Observable<Announcement[]> {
    return this.http.post<Announcement[]>(`${environment.apiUrl}/Announcement/Update`, announcement);
  }
}
